import { useState, useEffect } from "react";
import axios from "axios";
import { Modal, Spinner } from "react-bootstrap";
import { IoMdPause } from "react-icons/io";
import { GrDocumentText } from "react-icons/gr";
import { FaSpinner } from "react-icons/fa6";
import Swal from "sweetalert2";

import "./style.css";

const BatchFat = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sendingId, setSendingId] = useState(null);

  const getData = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/fat_batch`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (res.data.code === 1) {
        setData(res.data.data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const postData = async (id) => {
    setSendingId(id);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/fat_batch/postBatch`,
        { invoice_id: id },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (res.data.code === 1) {
        Swal.fire({
          title: "Success",
          icon: "success",
          customClass: {
            confirmButton: "btn-ok",
            title: "alert-title",
            popup: "alert-bg",
          },
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error al enviar los datos",
        icon: "error",
        customClass: {
          confirmButton: "btn-ok",
          title: "alert-title",
          popup: "alert-bg",
        },
      });
    } finally {
      setSendingId(null);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <h2 className="page-header">Facturación</h2>
          </div>
        </div>
        <div className="row">
          <div className="table-responsive col-md-12 mt-4">
            <table className="table table-striped">
              <thead className="text-center">
                <tr>
                  <th></th>
                  <th>Folio</th>
                  <th>Master</th>
                  <th>House</th>
                  <th>Fecha y hora</th>
                  <th>Agencia/Almacén</th>
                  <th>Monto total</th>
                  <th>Estatus</th>
                  <th style={{ width: "130px", minWidth: "130px" }}>
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody className="text-center">
                {loading ? (
                  <tr>
                    <td colSpan="9">Cargando...</td>
                  </tr>
                ) : data.length > 0 ? (
                  data.map((item, index) => (
                    <tr key={item.id}>
                      <td>
                        <span
                          style={{
                            display: "inline-block",
                            width: "12px",
                            height: "12px",
                            borderRadius: "50%",
                            backgroundColor: item.color_status,
                          }}
                        />
                      </td>
                      <td>{item.folio}</td>
                      <td>{item.awb}</td>
                      <td>{item.hbs}</td>
                      <td>{new Date(item.date).toLocaleString()}</td>
                      <td>{item.client}</td>
                      <td>{item.total}</td>
                      <td>{item.status}</td>
                      <td className="actions-cell">
                        <div className="actions-wrapper">
                          <span className="icon-btn">
                            {sendingId === item.id ? (
                              <FaSpinner className="spinner-icon" />
                            ) : (
                              <GrDocumentText
                                onClick={() => postData(item.id)}
                              />
                            )}
                          </span>

                          <span className="icon-btn">
                            <IoMdPause />
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9">No hay registros</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <Modal
        show={loading}
        onHide={() => {
          setLoading(false);
        }}
        backdrop="static"
        keyboard={false}
        centered
        dialogClassName="custom-modal"
        backdropClassName="custom-backdrop"
      >
        <div className="spinner-container">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </Spinner>
        </div>
      </Modal>
    </>
  );
};

export default BatchFat;
